import homeImg from 'assets/images/home.png';
import automationImg from 'assets/images/automation.png';
import managementImg from 'assets/images/manage.png';

const generalServerAdmin = {
    id: 'general',
    title: 'General',
    type: 'group',
    children: [
        {
            id: 'home',
            title: 'Home',
            type: 'item',
            url: '/home',
            icon: homeImg,
            breadcrumbs: false
        },
        {
            id: 'automation',
            title: 'Automation',
            type: 'item',
            url: '/automation',
            icon: automationImg,
            breadcrumbs: false
        },
        {
            id: 'management',
            title: 'Management',
            type: 'collapse',
            icon: managementImg,
            children: [
                {
                    id: 'devices',
                    title: 'Devices',
                    type: 'item',
                    url: '/management/devices',
                    breadcrumbs: false
                },
                {
                    id: 'groups',
                    title: 'Groups',
                    type: 'item',
                    url: '/management/groups',
                    breadcrumbs: false
                },
                {
                    id: 'policies',
                    title: 'Policies',
                    type: 'item',
                    url: '/management/policies',
                    breadcrumbs: false
                },
                {
                    id: 'license',
                    title: 'Licenses',
                    type: 'item',
                    url: '/management/licenses',
                    breadcrumbs: false
                },
                {
                    id: 'reference',
                    title: 'Reference',
                    type: 'item',
                    url: '/management/reference',
                    breadcrumbs: false
                },
                {
                    id: 'users',
                    title: 'Users',
                    type: 'item',
                    url: '/management/users',
                    breadcrumbs: false
                },
                {
                    id: 'permissions',
                    title: 'Permissions',
                    type: 'item',
                    url: '/management/permissions',
                    breadcrumbs: false
                },
                {
                    id: 'organization',
                    title: 'Organizations',
                    type: 'item',
                    url: '/management/organizations',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default generalServerAdmin;
